import Loading from "shared/components/Spin";
import { TEMPLATES } from "utils/constants";
import CollectionNeeds from "./CollectionNeeds";
import Comparison from "./Comparison";
import Contact from "./Contact";
import Contract from "./Contract";
import Default from "./Default";
import Fast from "./Fast";
import Quote from "./Quote";
import SelectProducts from "./SelectProducts";
import Upsells from "./Upsells";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.CONTRACT]: Contract,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.FAST]: Fast,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.COLLECTION_NEEDS]: CollectionNeeds,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.SELECT_PRODUCTS]: SelectProducts,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.COMPARISON]: Comparison,
  [TEMPLATES.B2B.THEMES.B2B_MUTUAL_MOBILITY.UPSELLS]: Upsells,
  default: Default,
};
export default Templates;
